import {
    Checkbox,
    Dropdown,
    Icon,
    PrimaryButton,
    Stack,
    TextField,
    Calendar,
    defaultCalendarStrings,
} from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import Moment from "moment";

import "./ErrorStudyFilter.css";
import { useTranslation } from "react-i18next";

const initialState = {
    dateFrom: new Date(),
    dateTo: new Date(),
};
  
const ErrorStudyFilter = (props) => {
    const ref = useRef(null);
    const { onClickOutside } = props;

    const [t] = useTranslation();

    const formatDate = (date) => {
        var currentDate = Moment(date).local().format("YYYY-MM-DD");
        return date == "" ? "" : currentDate;
    };
  
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
          onClickOutside && onClickOutside();
        }
      };
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }, [onClickOutside]);
  
    if (!props.show) return null;
  
    const calendarStyle = {
      root: {
        color: "#A19F9D",
      },
      goTodayButton: {
        color: "#A19F9D",
      },
      headerIconButton: {
        color: "#A19F9D",
      },
      daySelected: {
        background: "#5A5A5A",
      },
      dayIsToday: {
        background: "red",
      },
      liveRegion: {
        color: "#A19F9D",
      },
      weekDayLabelCell: {
        paddingLeft: "2px",
      },
    };

    const dateFromFunction = (event) => {
        props.setErrorStudyFilterObj({ ...props.errorStudyFilterObj, dateFrom: event });
    };

    const dateToFunction = (event) => {
        props.setErrorStudyFilterObj({ ...props.errorStudyFilterObj, dateTo: event });
    };
  
    return (
      <>
        <div className="error-filter-popup" ref={ref}>
          {
            <>
            <div className="date-filter-section align-filter-section">
                <span className="filter-section-text">{t("error-study-list.error-date-from")}</span>
                <div
                  className="modal-scroll"
                  style={{ height: "280px", overflowY: "auto" }}
                >
                  <ul className="date-from-ul">
                    <Calendar
                      showMonthPickerAsOverlay={true}
                      placeholder={t("error-study-list.start-date-placeholder")}
                      ariaLabel="Select a date"
                      // DatePicker uses English strings by default. For localized apps, you must override this prop.
                      styles={calendarStyle}
                      showGoToToday={false}
                      strings={defaultCalendarStrings}
                      onSelectDate={dateFromFunction}
                      // value={props.auditFilterObj.endDateObj}
                    />
                  </ul>
                </div>
              </div>
            </>
          }
          <div className="filter-section-seperator"></div>
          {
            <>
            <div className="date-filter-section align-filter-section">
                <span className="filter-section-text">{t("error-study-list.error-date-to")}</span>
                <div
                  className="modal-scroll"
                  style={{ height: "280px", overflowY: "auto" }}
                >
                  <ul className="date-from-ul">
                    <Calendar
                      showMonthPickerAsOverlay={true}
                      placeholder={t("error-study-list.end-date-placeholder")}
                      ariaLabel="Select a date"
                      // DatePicker uses English strings by default. For localized apps, you must override this prop.
                      styles={calendarStyle}
                      showGoToToday={false}
                      strings={defaultCalendarStrings}
                      onSelectDate={dateToFunction}
                      // value={props.auditFilterObj.endDateObj}
                    />
                  </ul>
                </div>
              </div>
            </>
          }
        </div>
      </>
    );
  };
  
  export default ErrorStudyFilter;